import { render, staticRenderFns } from "./VariantsModal.vue?vue&type=template&id=b5d5fdc2&"
import script from "./VariantsModal.vue?vue&type=script&lang=js&"
export * from "./VariantsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports